import React from 'react';
import PropTypes from 'prop-types';

const Hotel = ({ className, checked }) => (
    <svg
        width="56px"
        height="56px"
        viewBox="0 0 56 56"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} ${checked ? 'path__fill__checked' : 'path__fill'}`}
    >
        <title>Hotel Particulier</title>
        <desc>Created with Sketch.</desc>
        <defs>
            <polygon id="path-1" points="0 35.9854 52 35.9854 52 0.0004 0 0.0004" />
        </defs>
        <g id="assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.6">
            <g id="Hotel">
                <g id="Page-1" transform="translate(2.000000, 11.000000)">
                    <g id="Clip-5" />
                    <path
                        d="M48.0001,13.9854 L36.9561,13.9854 L36.0001,13.9854 L36.0001,10.9854 C36.0001,10.7384 35.9081,10.5004 35.7431,10.3164 L31.8461,5.9854 L44.4341,5.9854 L49.2331,13.9854 L48.0001,13.9854 Z M47.0001,33.9854 L36.0001,33.9854 L36.0001,15.9854 L36.9561,15.9854 L47.0001,15.9854 L47.0001,33.9854 Z M31.0001,33.9854 L31.0001,22.9854 C31.0001,21.8824 30.1031,20.9854 29.0001,20.9854 L23.0001,20.9854 C21.8971,20.9854 21.0001,21.8824 21.0001,22.9854 L21.0001,33.9854 L18.0001,33.9854 L18.0001,11.3694 L26.0001,2.4804 L34.0001,11.3694 L34.0001,33.9854 L31.0001,33.9854 Z M23.0001,33.9854 L29.0001,33.9854 L29.0001,22.9854 L23.0001,22.9854 L23.0001,33.9854 Z M5.0001,15.9854 L15.0431,15.9854 L16.0001,15.9854 L16.0001,33.9854 L5.0001,33.9854 L5.0001,15.9854 Z M7.5661,5.9854 L20.1551,5.9854 L16.2571,10.3164 C16.0911,10.5004 16.0001,10.7384 16.0001,10.9854 L16.0001,13.9854 L15.0431,13.9854 L4.0001,13.9854 L2.7661,13.9854 L7.5661,5.9854 Z M51.8571,14.4704 L45.8571,4.4704 C45.6771,4.1694 45.3521,3.9854 45.0001,3.9854 L30.0451,3.9854 L26.7431,0.3164 C26.3641,-0.1056 25.6361,-0.1056 25.2571,0.3164 L21.9551,3.9854 L7.0001,3.9854 C6.6491,3.9854 6.3231,4.1694 6.1431,4.4704 L0.1431,14.4704 C-0.0429,14.7794 -0.0479,15.1644 0.1301,15.4784 C0.3071,15.7914 0.6401,15.9854 1.0001,15.9854 L3.0001,15.9854 L3.0001,34.9854 C3.0001,35.5384 3.4481,35.9854 4.0001,35.9854 L17.0001,35.9854 L21.0001,35.9854 L21.5791,35.9854 L22.0001,35.9854 L30.0001,35.9854 L30.4211,35.9854 L35.0001,35.9854 L48.0001,35.9854 C48.5531,35.9854 49.0001,35.5384 49.0001,34.9854 L49.0001,15.9854 L51.0001,15.9854 C51.3601,15.9854 51.6921,15.7914 51.8701,15.4784 C52.0481,15.1644 52.0431,14.7794 51.8571,14.4704 L51.8571,14.4704 Z"
                        id="Fill-1"
                        fill="#393939"
                    />
                    <path
                        d="M9,28.9854 L12,28.9854 L12,22.9854 L9,22.9854 L9,28.9854 Z M13,20.9854 L8,20.9854 C7.448,20.9854 7,21.4324 7,21.9854 L7,29.9854 C7,30.5384 7.448,30.9854 8,30.9854 L13,30.9854 C13.552,30.9854 14,30.5384 14,29.9854 L14,21.9854 C14,21.4324 13.552,20.9854 13,20.9854 L13,20.9854 Z"
                        id="Fill-4"
                        fill="#393939"
                    />
                    <path
                        d="M40,28.9854 L43,28.9854 L43,22.9854 L40,22.9854 L40,28.9854 Z M39,30.9854 L44,30.9854 C44.553,30.9854 45,30.5384 45,29.9854 L45,21.9854 C45,21.4324 44.553,20.9854 44,20.9854 L39,20.9854 C38.447,20.9854 38,21.4324 38,21.9854 L38,29.9854 C38,30.5384 38.447,30.9854 39,30.9854 L39,30.9854 Z"
                        id="Fill-6"
                        fill="#393939"
                    />
                    <path
                        d="M22.1265,14.4854 C22.5715,12.7624 24.1395,11.4854 26.0005,11.4854 C27.8605,11.4854 29.4285,12.7624 29.8735,14.4854 L22.1265,14.4854 Z M26.0005,9.4854 C22.6915,9.4854 20.0005,12.1764 20.0005,15.4854 C20.0005,16.0374 20.4475,16.4854 21.0005,16.4854 L31.0005,16.4854 C31.5525,16.4854 32.0005,16.0374 32.0005,15.4854 C32.0005,12.1764 29.3085,9.4854 26.0005,9.4854 L26.0005,9.4854 Z"
                        id="Fill-7"
                        fill="#393939"
                    />
                </g>
            </g>
        </g>
    </svg>
);

Hotel.displayName = 'Hotel';

Hotel.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

/**
 * Hotel Functional Component.
 */
export default Hotel;
